export default "__VITE_ASSET__j2LnpOIJ__"